/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { Link } from "react-router-dom";
import { getUserRoutes } from "../../services/myRoute.service";
import { useSelector } from "react-redux";
import { uploadAds } from "../../services/auth.service";

const CreateNewAds = ({
  route,
  setRoute,
  showModal,
  toggle,
  createNewRoute,
  selectRoute,
  showSpinner,
}) => {
  const [routepoint, setRoutePoint] = useState([]);
  const [showClear, setShowClear] = useState("none");
  const [errors, setErrors] = useState({});
  const [adTitle, setAdTitle] = useState("");
  const [adUrl, setAdUrl] = useState("");
  const [showUrlClear, setShowUrlClear] = useState("none");
  const [fileDetail, setFileDetail] = useState(null);
  const [fileContent, setFileContent] = useState("");
  const [fileName, setFileName] = useState("");
  const [fileType, setFileType] = useState("");
  const [adType, setAdType] = useState("");

  const userName = useSelector(
    (state) => state?.userDetailReducer?.userData?.userName
  );
  const isUserLoggedIn = localStorage.getItem("token");

  const adTypeData = [
    {
      value: 1,
      label: "Mkm",
    },
    {
      value: 2,
      label: "Tzadikim",
    },
    {
      value: 3,
      label: "Outside Link",
    },
    {
      value: 4,
      label: "Image",
    },
  ];

  useEffect(() => {
    if (showModal) {
      fetchUserRoutes();
    }
  }, [showModal]);

  const fetchUserRoutes = async () => {
    if (isUserLoggedIn) {
      try {
        const response = await getUserRoutes({
          userName: userName,
        });
        if (response && response?.status === 200) {
          setRoutePoint(response?.data?.data?.data);
        }
      } catch (err) {
        if (err.response && err.response.status === 401) {
          localStorage.clear();
          window.location.href = "/";
        }
      }
    }
  };

  const handleAdTitle = (e) => {
    setAdTitle(e.target.value);
    setErrors({
      [e?.target?.id]: null,
    });
    if (adTitle === "") {
      setShowClear("none");
    } else {
      setShowClear("block");
    }
  };

  const clearAdTitle = () => {
    setAdTitle("");
    setShowClear("none");
  };

  const handleAdUrl = (e) => {
    setAdUrl(e.target.value);
    setErrors({ [e?.target?.id]: null });
    if (adUrl === "") {
      setShowUrlClear("none");
    } else {
      setShowUrlClear("block");
    }
  };

  const clearAdUrl = () => {
    setAdUrl("");
    setShowUrlClear("none");
  };

  const handleFileChange = (e) => {
    setFileDetail(e.target.files[0]);
    setFileName(e.target.files[0].name);
    setFileType(e.target.files[0].type);

    const reader = new FileReader();
    reader.onloadend = () => {
      console.log(reader.result.split(",")[1], "reader result");
      setFileContent(reader.result.split(",")[1]);
    };
    reader.readAsDataURL(e.target.files[0]);
  };

  const handleAdType = (e) => {
    setAdType(e.target.value);
  };

  let data = {
    adTitle: adTitle,
    adUrl: adUrl,
    adType: Number(adType),
    fileName: fileName,
    fileType: fileType,
    fileContent: fileContent,
    mkmId: 102,
  };

  const handlesubmit = (e) => {
    e.preventDefault();
    uploadAds(data)
      .then((data) => console.log(data))
      .catch((err) => console.log(err));
      setAdTitle('');
      setAdUrl('');
      setAdType('');
      setFileName('');
      setFileContent('');
      toggle();
  };

  return (
    <>
      <Modal
        className="select_route modal-dialog-centered"
        isOpen={showModal}
        toggle={toggle}
      >
        <ModalHeader toggle={toggle}>Create new Ads</ModalHeader>
        <ModalBody>
          <Form className="form" onSubmit={handlesubmit}>
            {isUserLoggedIn ? (
              <>
                <FormGroup>
                  <div className="form_lab">
                    <Label>Ad Title</Label>
                    <button
                      className="clear-btn"
                      type="button"
                      onClick={clearAdTitle}
                      style={{ display: showClear }}
                    >
                      clear
                    </button>
                  </div>
                  <Input
                    type="text"
                    autoComplete="off"
                    name="adTitle"
                    id="adTitle"
                    maxLength="100"
                    placeholder="Ad Title"
                    value={adTitle}
                    onChange={handleAdTitle}
                  />
                </FormGroup>
                <FormGroup>
                  <div className="form_lab">
                    <Label>Ad Url</Label>
                    <button
                      className="clear-btn"
                      type="button"
                      style={{ display: showUrlClear }}
                      onClick={clearAdUrl}
                    >
                      clear
                    </button>
                  </div>
                  <Input
                    type="text"
                    autoComplete="off"
                    name="adUrl"
                    id="adUrl"
                    maxLength="100"
                    placeholder="Ad Url"
                    value={adUrl}
                    onChange={handleAdUrl}
                  />
                </FormGroup>
                <FormGroup>
                  <div className="form_lab">
                    <Label>Ad Type</Label>
                    <select
                      name="adType"
                      id="adType"
                      onChange={handleAdType}
                      value={adType}
                    >
                      <option value={""}>Select Ad type</option>
                      {adTypeData.map((item) => (
                        <option key={item.value} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </FormGroup>
                <FormGroup>
                  <div className="form_lab">
                    <Label>Upload File</Label>
                  </div>
                  <Input
                    type="file"
                    name="file"
                    id="file"
                    onChange={handleFileChange}
                  />
                </FormGroup>
                <ModalFooter>
                  <Button color="primary" type="submit">
                    Submit
                  </Button>
                </ModalFooter>
              </>
            ) : (
              <p>
                {" "}
                You want to see your list? Please continue to &nbsp;
                <Link to="/sign-in">Log In</Link>.
              </p>
            )}
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};

export default CreateNewAds;
